const collator = new Intl.Collator("et", { numeric: true, sensitivity: "base" });

const startsWithDigit = (s: string) => /^\d/.test(s.trimStart());

export function compareFolderNames(a: string, b: string): number {
  const aNum = startsWithDigit(a);
  const bNum = startsWithDigit(b);
  if (aNum && !bNum) return -1;
  if (!aNum && bNum) return 1;
  return collator.compare(a, b);
}

export function sortTreeFolders<T extends { name: string; children: T[] }>(nodes: T[]): T[] {
  nodes.sort((a, b) => compareFolderNames(a.name, b.name));
  nodes.forEach((n) => sortTreeFolders(n.children));
  return nodes;
}
